<template>
  <div class="grey-chat-widget" :class="{'short-chart': short}">
    <canvas :id="`myChart${id}`" width="400" height="400"></canvas>
  </div>
</template>

<script>
/* eslint-disable */
import Zoom from "chartjs-plugin-zoom";
// var myChart = {};
// var ctx = {};
const DEFAULT_OPTIONS = {
  legend: {
    labels: {}
  },
  responsive: true,
  maintainAspectRatio: false,
  pan: {
    enabled: true,
    mode: "x" // is panning about the y axis neccessary for bar charts?
  },
  zoom: {
    enabled: true,
    mode: "x"
  },
  major: {
    ticks: {}
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true
        }
      }
    ],
    xAxes: [
      {
        ticks: {
          // maxTicksLimit: 5
        }
      }
    ]
  }
};
export default {
  name: "grey-chart",
  props: ["options", "data", "type", "id","short"],
  data: function() {
    return {};
  },
  components: {},
  methods: {
    reload(newData, newType,options = {}) {
      this.drawChart(newData, newType,options);
      // alert("reloading");
    },
    drawChart(data, type, options = {}) {
      let ctx = document.getElementById(`myChart${this.id}`).getContext("2d");
      let myChart = new Chart(ctx, {
        plugins: [Zoom],
        type: type,
        data: data,
        options: {...DEFAULT_OPTIONS,...options}
      });
    }
  },
  mounted() {
    let ctx = document.getElementById(`myChart${this.id}`).getContext("2d");
    // console.log(this.id)
    this.drawChart(this.data, this.type, this.options);
  },
  updated() {}
};
</script>

<style lang="scss" scoped>
.grey-chat-widget {
  height: 400px;
  &.short-chart{
    height: 200px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/grey-chart.vue